const routes = [
  {
    path: "/appointment-list",
    component: () => import(/* webpackChunkName: "BookingsIndex" */ "./views/BookingsIndex"),
    children: [
      {
        path: "online-scheduling-upsell",
        name: "onlineSchedulingUpsellPage",
        component: () => import(/* webpackChunkName: "onlineSchedulingUpsell" */ "./views/onlineSchedulingUpsellPage/onlineSchedulingUpsellPage")
      },
      {
        path: "booking",
        name: "newBookingDialog",
        component: () => import(/* webpackChunkName: "newBooking" */ "./views/newBooking/newBooking")
      },
      {
        path: "blocked-off-time",
        name: "newBlockedOffTimeDialog",
        component: () => import(/* webpackChunkName: "newBlockedOffTime" */ "./views/newBlockedOffTime/newBlockedOffTime")
      },
      {
        path: "",
        name: "bookings",
        component: () => import(/* webpackChunkName: "BookingsPage" */ "./views/bookingPage/BookingsPage")
      },
      {
        path: "/appointment-waitlist-upsell-dialog",
        name: "appointmentWaitlistUpsellDialog",
        component: () => import(/* webpackChunkName: "BookingsUpsellPage" */"./components/list/appointmentWaitlistUpsellDialog/appointmentWaitlistUpsellDialog")
      },
      {
        path: "/waitlist-disable",
        name: "WaitlistDisable",
        component: () => import(/* webpackChunkName: "WaitlistDisablePage" */"./components/common/waitlistDisableDialog/waitlistDisableDialog")
      },
      {
        path: "/schedule-upgrade",
        component: () => import(/* webpackChunkName: "upgrade" */ "./views/Upgrade")
      },
      {
        path: "/additional-staff-dialog",
        name: "additionalStaffDialog",
        component: () => import(/* webpackChunkName: "additionalStaffDialog" */ "./views/additionalStaffDialog/additionalStaffDialog"),
      },
      {
        path: "bulk-cancel-multi-booking",
        name: "BulkCancelMultiBookingPage",
        component: () => import(/* webpackChunkName: "BulkCancelMultiBookingPage" */ "./components/NewBooking/MultiBooking/bulkActions/BulkCancelMultiBookingPage"),
      },
      {
        path: "*",
        redirect: { name: "bookings" }
      }
    ]
  },
];
export default routes;
